import React from "react";
import { Row } from "reactstrap";

import SummaryTitle from "./SummaryTitle";

export default function MenuButtons() {
  return (
    <div>
      <div className="p-3" style={{ height: "58px" }}>
        <Row>
          <SummaryTitle />
        </Row>
      </div>
      <hr />
    </div>
  );
}
